import { useMemo } from 'react';
import { RadioOption } from 'components/RadioGroupField/RadioGroupField.component';
import { useTranslation } from 'react-i18next';
import { PRICE_DESCRIPTION, PriceDescription } from 'models/Listing';
import utils from 'utils';
import { STOCK_AT_VALUE, StockAtValue } from 'models/DealRoom';
import { useFormState } from 'react-final-form';

export function useGenerateSliderOptions() {
  const { t } = useTranslation();

  const {
    values: { priceDescription },
  } = useFormState();

  const isFuture = priceDescription === PRICE_DESCRIPTION.FORECAST;

  const stockAtValueOptions = useMemo<RadioOption<StockAtValue>[]>(
    () => [
      {
        label: t('includesStockAtValue'),
        value: STOCK_AT_VALUE.INCLUDE_STOCK_AT_VALUE,
      },
      {
        label: t('excludesStockAtValue'),
        value: STOCK_AT_VALUE.EXCLUDE_STOCK_AT_VALUE,
      },
      {
        label: t('noStockAtValue'),
        value: STOCK_AT_VALUE.NO_STOCK_AT_VALUE,
      },
    ],
    [t],
  );

  const descriptionPriceOptions = useMemo<RadioOption<PriceDescription>[]>(
    () => [
      { label: t('actual'), value: PRICE_DESCRIPTION.ACTUAL },
      {
        label: t('forecast'),
        value: PRICE_DESCRIPTION.FORECAST,
      },
    ],
    [t],
  );

  const accountingPeriodOptions = useMemo<RadioOption<string>[]>(
    () =>
      utils.generateNumberOfYears(5, isFuture).map((el) => ({
        label: t(`FY${el}`),
        value: `fy${el}`,
      })),
    [isFuture, t],
  );

  return {
    stockAtValueOptions,
    descriptionPriceOptions,
    accountingPeriodOptions,
  };
}
